var angular = require('angular')
require('../../services/app-data.service.js')

angular.module('AemBranchesAppointments')
  .component('appointmentServices', {
    template: require('./appointment-services.component.tpl.html'),
    controller: AppointmentServicesCtrl,
    controllerAs: 'vm',
    bindings: {
      onServiceChange: '&'
    }
  })

AppointmentServicesCtrl.$inject = ['appDataService', '$filter']

function AppointmentServicesCtrl (appDataService, $filter) {
  var vm = this

  vm.$onInit = function () {
    vm.noOptionId = 'radio_no_' + guid()
    vm.yesOptionId = 'radio_yes_' + guid()
    vm.needService = appDataService.getNeedAnyService()
    vm.tips = [$filter('translate')('BRANCHES_APPOINTMENTS.SERVICE.HINT.TEXT')]
    vm.servicesChange = servicesChange
    vm.serviceChange = serviceChange
    vm.sortedServices = appDataService.sortedServices
    vm.serviceGroups = appDataService.serviceGroups
  }

  function servicesChange () {
    if (!vm.needService) {
      appDataService.resetAllServices()
      appDataService.setQueryParams()
      vm.onServiceChange()
    }
  }

  function serviceChange (service) {
    appDataService.setQueryParams()
    vm.onServiceChange()
  }

  function guid () {
    function s4 () {
      return Math.floor((1 + Math.random()) * 0x10000).toString(16).substring(1)
    }
    return s4() + s4() + '-' + s4() + '-' + s4() + '-' + s4() + '-' + s4() + s4() + s4()
  }
}
